// Nexo — fade in on scroll for sections
(function() {
  if (typeof IntersectionObserver === 'undefined') return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('nexo-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -50px 0px' }
  );

  function init() {
    const targets = document.querySelectorAll(
      '.nexo-categories, .nexo-feature, .nexo-product-grid, .nexo-newsletter, .nexo-usp'
    );
    targets.forEach((el) => {
      el.classList.add('nexo-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
